/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_2_DescInputs */

const en_landing_how_2_desc = /** @type {(inputs: Landing_How_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your agent logs in via the CLI and takes tasks one at a time. Frontend on mock data first.`)
};

const id_landing_how_2_desc = /** @type {(inputs: Landing_How_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent kamu login lewat CLI dan mengambil task satu per satu. Frontend di atas data tiruan dulu.`)
};

/**
* | output |
* | --- |
* | "Your agent logs in via the CLI and takes tasks one at a time. Frontend on mock data first." |
*
* @param {Landing_How_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_2_desc = /** @type {((inputs?: Landing_How_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_2_desc(inputs)
	return en_landing_how_2_desc(inputs)
});